// import React, { useEffect, useRef, useState } from 'react'
import { ArrowRightOutlined } from '@ant-design/icons';
import { Display } from '../Display/Display';
import { Popover } from 'antd';
import { contentType } from '../../utils/Page/constant';
import './style.scss';
import { useEffect, useState } from 'react';

import SiteImage from '../SiteImage';
import FileType from '../FileType';
const Content = (props: any) => {
    let { onClick, type, side, ...otherProps } = props;
    return (
        <span
            className="citation-brief"
            onClick={() => {
                onClick({
                    type: type,
                    ...otherProps
                });
            }}
        >
            <span className="brief-title ellipsis-2">{otherProps.title}</span>
            <Display show={type === contentType.web_search}>
                <span className="brief-origin  ellipsis-2">
                    <span className="left">
                        <SiteImage src={otherProps.icon}></SiteImage>
                        {otherProps.site_name}
                    </span>
                    <span>
                        <ArrowRightOutlined />
                    </span>
                </span>
            </Display>
            <Display show={type === contentType.retrieval}>
                <span className="brief-origin  ellipsis-2">
                    <FileType fileName={otherProps.title}></FileType>

                    <Display show={false}>
                        <span>
                            <ArrowRightOutlined />
                        </span>
                    </Display>
                </span>
            </Display>
        </span>
    );
};
export const Citation = (props: any) => {
    const [data, setData] = useState<any>({});
    let { children } = props;
    const getData = () => {
        let list = [];
        if (props.type === contentType.web_search) {
            list = props?.web_result?.data || [];
        }
        if (props.type === contentType.retrieval) {
            list = props?.retrieval_result?.data || [];
        }
        let res = list.find((ele: any) => {
            return ele.id === props.id;
        });
        setData(res);
    };
    useEffect(() => {
        getData();
    }, [props.type]);
    return (
        <>
            <Display show={props.side === 'web' && data?.id}>
                <Popover
                    rootClassName="grt-citation-box"
                    title={null}
                    content={<Content {...data} {...props}></Content>}
                    arrow={false}
                    trigger="hover"
                >
                    <span className="grt-citation">{children}</span>
                </Popover>
            </Display>
            <Display show={props.side === 'mobile' || !data?.id}>
                <span
                    onClick={() => {
                        props.onClick({
                            type: props.type,
                            ...data
                        });
                    }}
                    className="grt-citation"
                >
                    {children}
                </span>
            </Display>
        </>
    );
};

export default Citation;
